export enum ProductAvailabilityNotificationStatus {
    Input,
    Success,
    LimitExceeded
}
